import { UndergradLive } from '@/models/undergrad/undergrad-live.model';
import { isGreaterThan } from '@/helpers/date';

export const LIVE_TYPE = {
  live: 'live',
  vod: 'rerun',
};

export const getEventLiveType = (live: UndergradLive) => {
  const todayDate = new Date().toISOString();

  if (live.transmissionEndDate) {
    const isLive = isGreaterThan(live.transmissionEndDate.toISOString(), todayDate);

    return isLive ? LIVE_TYPE.live : LIVE_TYPE.vod;
  }

  return LIVE_TYPE.vod;
};
